// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.audit-row-clickable[data-v-78164c48] {\n  cursor: pointer;\n}\n.action-btn-disabled[data-v-78164c48] {\n  opacity: 0.9 !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
